import { gql } from '@apollo/client';

export const TEST_MEDIA_EXTRACTION_ADMIN = gql`
    mutation TestMediaExtractionAdmin($data: TestMediaExtractionAdminInput!) {
        testMediaExtractionAdmin(data: $data) {
            success
            action
            playerClient
            proxyMode
            durationMs
            title
            channel
            durationSeconds
            streamHost
            streamHttpStatus
            selectedFormatId
            downloadSizeBytes
            downloadUrl
            transcriptionSample
            cookiesUsed
            serverCookiesConfigured
            formats {
                formatId
                extension
                codec
                audioCodec
                videoCodec
                bitrate
                filesize
                hasDirectUrl
                urlHost
            }
            logs
            error
        }
    }
`;
